export default __webpack_public_path__ + "static/marketplace-solution-resource-img-9ada308b8bfdc78589100f56f977ccba.png";